import { useQuery } from '@tanstack/react-query';
import { getPaymentStatusChanges } from '@/lib/api/payment-status';
// POC: re-enable when payments feature is fully implemented
// import { useMode } from "@/providers/ModeProvider";
import type { PaymentStatusChange } from '@/types/api/payment-status';

/**
 * Hook to fetch payment link status changes from external API.
 * Returns a lookup map keyed by externalReference for easy matching
 * against transaction reference numbers.
 *
 * Skipped entirely in Demo mode.
 */
export function usePaymentStatusChanges() {
  // const { isDemo } = useMode();

  return useQuery<Map<string, PaymentStatusChange>, Error>({
    queryKey: ['payment-status-changes'],
    queryFn: async ({ signal }) => {
      const response = await getPaymentStatusChanges(signal);
      const map = new Map<string, PaymentStatusChange>();
      for (const change of response.changes) {
        map.set(change.externalReference, change);
      }
      return map;
    },
    // POC: Payment status polling disabled until payments feature is fully implemented
    enabled: false,
    staleTime: 0,
    refetchOnMount: 'always',
  });
}
